import type { RouteObject } from "react-router-dom";
import { internalUserRoutes } from "./InternalUserRoutes";
import { Auth } from "@dealer-center/core-pages-auth";
import { publicRoutes } from "./public-pages";
import { RequireInternalUser } from "./RequireInternalUser";
import { Layout } from "./Layout";
import { useSystemStore } from "@dealer-center/ddc-state-system";
import { getControlCenterRoutes } from "@dealer-center/ddc-pages-controlcenter-react";
import { AppHooks } from "../AppHooks";
import { useValidateJwt } from "@dealer-center/ddc-api-auth-fetch";
import { useGetUser } from "@dealer-center/ddc-api-user-fetch";

export const useAppRoutes = (): RouteObject[] => {
  const userState = useGetUser();
  const authState = useValidateJwt();
  const { enviroment } = useSystemStore();
  return [
    {
      path: "/",
      element: <Auth auth={authState} user={userState} />,
      children: [
        {
          element: <AppHooks />,
          children: [
            {
              element: <Layout />,
              children: [
                {
                  element: <RequireInternalUser />,
                  children: internalUserRoutes(enviroment)
                }
              ]
            }
          ]
        }
      ]
    },
    publicRoutes,
    ...getControlCenterRoutes(
      enviroment,
      <Auth auth={authState} user={userState} />
    )
  ] as RouteObject[];
};
